const ZoomOutIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.0513 27.6973L37.1892 34.8351L34.8322 37.1921L27.6943 30.0543C25.1278 32.1076 21.873 33.3359 18.333 33.3359C10.053 33.3359 3.33301 26.6159 3.33301 18.3359C3.33301 10.0559 10.053 3.33594 18.333 3.33594C26.613 3.33594 33.333 10.0559 33.333 18.3359C33.333 21.8759 32.1047 25.1308 30.0513 27.6973ZM11.6663 16.6693V20.0026H24.9997V16.6693H11.6663Z"
        fill="#322D24"
      />
    </svg>
  );
};

export default ZoomOutIcon;
